import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingFormTypes } from "models/formTypes";
import { MonthlyFormContainerProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import MonthlyForm from "./monthlyForm";
import { useSalaryPermissions } from "components/salary";
//#endregion
import * as Yup from "yup";

const MonthlyFormContainer: ForwardRefRenderFunction<FormHandles, MonthlyFormContainerProps> = (props, ref) => {
  const { onFormValidationChange, currentMetaData } = props;
  const formRef = React.useRef<FormHandles>(null);

  const { isSalaryDeviationsAvailable } = useSalaryPermissions();

  React.useImperativeHandle(ref, () =>
    formRef.current
      ? {
          ...formRef.current,
        }
      : ({} as FormHandles)
  );

  const initialValues = props.currentMonth ?? {
    rows: [],
  };

  const validationSchema = Yup.object<TimeReportingFormTypes.MonthlyTimeReport>({
    rows: Yup.array().of(
      Yup.object<TimeReportingFormTypes.MonthlyTimeReportRow>({
        name: Yup.string(),
      })
    ),
  });

  return (
    <MonthlyForm
      ref={formRef}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      tableHeaderValues={initialValues.tableHeader}
      headerRowValues={initialValues.headerRow}
      onFormValidationChange={onFormValidationChange}
      monthLockEntries={props.monthLockEntries}
      onFormUpdate={props.onFormUpdate}
      salaryDeviationActive={isSalaryDeviationsAvailable}
      weeksInMonth={props.weeksInMonth}
      dateRange={props.dateRange}
      employeeId={currentMetaData.employeeId}
    />
  );
};

export default forwardRef(MonthlyFormContainer);
